jQuery(function($) {

    smiBlock.get();

    smiDfp.addBreakpoint('adhesion', 0, 480, false);
    smiDfp.addBreakpoint('phone', 0, 767, false);
    smiDfp.addBreakpoint('tablet', 768, 1023, false);
    smiDfp.addBreakpoint('desktop', 1024, 0, true);

    smiDfp.addGlobalTargeting('loggedin', cphGlobal.getCookieByName('IsSubscriber') === 'True' ? 'true' : 'false');

    smiDfp.addKeywordSelector('.main-title');
    smiDfp.addKeywordSelector('.story-content');
    smiDfp.addKeyword('wildfire');
    smiDfp.addKeyword('firestorm');
    smiDfp.addKeyword('fires');
    smiDfp.addKeyword('cal fire');
    smiDfp.addKeyword('calfire');
    smiDfp.addKeyword('legal liability');
    smiDfp.addKeyword('disaster');
    smiDfp.addKeyword('lawsuit');

    var ad, wrap, shim, adDelay;

    ad = smiDfp.buildAd('tablet,desktop');
    ad.addTargeting('type', 'article');
    ad.addSize(1, 1);
    $('#one-by-one-ad').html(ad.render());

    ad = smiDfp.buildAd('phone,tablet,desktop');
    ad.addTargeting('type', 'teads');
    ad.addSize(2, 1);
    $('#one-by-one-ad').append(ad.render());

    wrap = smiDfp.buildAdWrapper();

    ad = smiDfp.buildAd('desktop');
    ad.addTargeting('position', 'ATF');
    ad.addTargeting('loc', '1');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);
    ad.addSize(970, 90);
    //ad.addSize(970, 250);
    ad.setForceReload();
    //ad.setNoReload();
    ad.wrapWith(wrap);

    ad = smiDfp.buildAd('tablet');
    ad.addTargeting('position', 'ATF');
    ad.addTargeting('loc', '1');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);
    ad.setForceReload();
    //ad.setNoReload();
    ad.wrapWith(wrap);

    $('#leaderboard-atf').html(wrap);

    var recipeLarge = $('#recipe-under-cover-ad-large'),
        recipeSmall = $('#recipe-under-cover-ad-small');

    if(recipeLarge.length) {
        wrap = smiDfp.buildAdWrapper();

        ad = smiDfp.buildAd('desktop');
        ad.addTargeting('position', 'ATF');
        ad.addTargeting('loc', '1');
        ad.addTargeting('type', 'article');
        ad.addSize(728, 90);
        ad.addSize(970, 90);
        ad.setDelay(500);
        ad.setForceReload();
        //ad.setNoReload();
        ad.wrapWith(wrap);

        ad = smiDfp.buildAd('tablet');
        ad.addTargeting('position', 'ATF');
        ad.addTargeting('loc', '1');
        ad.addTargeting('type', 'article');
        ad.addSize(728, 90);
        ad.setDelay(500);
        ad.setForceReload();
        //ad.setNoReload();
        ad.wrapWith(wrap);

        recipeLarge.html(wrap);
    }

    if(recipeSmall.length) {
        ad = smiDfp.buildAd('phone');
        ad.addTargeting('position', 'ATF');
        ad.addTargeting('loc', '1');
        ad.addTargeting('type', 'article');
        ad.addSize(320, 50);
        ad.setDelay(500);
        ad.setForceReload();
        //ad.setNoReload();

        recipeSmall.html(ad.render());
    }

    wrap = smiDfp.buildAdWrapper();

    ad = smiDfp.buildAd('desktop');
    ad.addTargeting('position', 'BTF');
    ad.addTargeting('loc', 'bottom');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);
    ad.addSize(970, 90);
    ad.addSize(970, 250);
    ad.setDelay(5000);
    ad.wrapWith(wrap);

    ad = smiDfp.buildAd('tablet');
    ad.addTargeting('position', 'BTF');
    ad.addTargeting('loc', 'bottom');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);
    ad.setDelay(5000);
    ad.wrapWith(wrap);

    ad = smiDfp.buildAd('phone');
    ad.addTargeting('position', 'BTF');
    ad.addTargeting('loc', 'bottom');
    ad.addTargeting('type', 'article');
    ad.addSize(300, 250);
    ad.setDelay(5000);
    ad.wrapWith(wrap);

    $('#leaderboard-btf').html(wrap);


    wrap = smiDfp.buildAdWrapper('pw-adhesion-wrap');
    ad = smiDfp.buildAd('adhesion');
    ad.addSize(320, 50);
    ad.addSize(320, 100);
    ad.addTargeting('position', 'ATF');
    //ad.setNoReload(); // turned off 9/14/2022 per request from JdC
    ad.wrapWith(wrap);

    $("#adhesion-ad").html(wrap);


    shim = smiDfp.buildAdShim('adhesion', '50px');
    $('#adhesion-shim').html(shim);

    adDelay = 0;
    $('.page-break-ad').each(function(i) {
        adDelay = adDelay + 500;

        wrap = smiDfp.buildAdWrapper('widget-centered', 'text-align: center;');

        ad = smiDfp.buildAd('desktop');
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 2);
        ad.addTargeting('position', ((i + 2) >= 4) ? 'ATF' : 'BTF');
        ad.addSize(728, 90);
        ad.addSize(970, 90);
        ad.addSize(970, 250);
        //ad.setShowOnScroll();
        ad.setDelay(adDelay);
        ad.wrapWith(wrap);

        ad = smiDfp.buildAd('tablet');
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 2);
        ad.addTargeting('position', ((i + 2) >= 4) ? 'ATF' : 'BTF');
        ad.addSize(728, 90);
        //ad.setShowOnScroll();
        ad.setDelay(adDelay);
        ad.wrapWith(wrap);

        ad = smiDfp.buildAd('phone');
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 2);
        ad.addTargeting('position', ((i + 2) >= 4) ? 'ATF' : 'BTF');
        ad.addSize(300, 250);
        //ad.setShowOnScroll();
        ad.setDelay(adDelay);
        ad.wrapWith(wrap);

        $(this).html(wrap);
    });

    adDelay = 500;
    $('.sidebar-cube-ad, .sidebar-half-ad, .sidebar-house-ad').each(function(i) {
        var cube = $(this),
            dataClass = cube.data('class'),
            dataTargeting = cube.data('targeting'),
            adClass = null,
            cubeLoc = 0,
            halfLoc = 0,
            houseLoc = 0,
            adLoc, adSize;

        adDelay = adDelay + 100;

        if(cube.hasClass('sidebar-half-ad')) {
            adSize = [300, 600];
            halfLoc = halfLoc + 1;
            adLoc = halfLoc;
        } else if(cube.hasClass('sidebar-house-ad')) {
            adSize = [300, 100];
            houseLoc = houseLoc + 1;
            adLoc = houseLoc;
        } else {
            adSize = [300, 250];
            cubeLoc = cubeLoc + 1;
            adLoc = cubeLoc;
        }

        if(dataClass && dataClass !== 'undefined') {
            adClass = dataClass;
        }

        ad = smiDfp.buildAd('desktop', adClass);
        ad.addSize(adSize[0], adSize[1]);
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', adLoc);
        //ad.setShowOnScroll();
        ad.setDelay(adDelay);
        if(dataTargeting && dataTargeting !== 'undefined') {
            $.each(dataTargeting, function(key, value) {
                ad.addTargeting(key, value);
            });
        }

        $(this).html(ad.render());
    });

    adDelay = 500;
    $('.article-inline-ad').each(function(i) {
        var cube = $(this),
            dataClass = cube.data('class'),
            dataTargeting = cube.data('targeting'),
            adClass = null;

        adDelay = adDelay + 500;

        if(dataClass && dataClass !== 'undefined') {
            adClass = dataClass;
        }

        wrap = smiDfp.buildAdWrapper('widget-centered', 'height: 250px; width: 300px; background-color: #F0F0F0; box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.3);');

        ad = smiDfp.buildAd('phone,tablet,desktop', adClass);
        ad.addSize(300, 250);
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 1);
        //ad.setShowOnScroll();
        ad.setDelay(adDelay);

        if(i === 0) { // do not reload first, mobile-only ad
            ad.setNoReload();
        }

        if(dataTargeting && dataTargeting !== 'undefined') {
            $.each(dataTargeting, function(key, value) {
                ad.addTargeting(key, value);
            });
        }
        ad.wrapWith(wrap);

        $(this).html(wrap);
    });

    smiDfp.loadAds();
});
// INSERT BEG INTO PREDEFINED DIV AFTER EACH STORY
/*if(cphPD) {
    jQuery(function($) {
        if(typeof pageTags !== 'object')
            return;

        if(pageTags.indexOf('2022_general_election') === -1)
            return;

        var afterStory = $('#beg-container'),
            isSubscribed = cphGlobal.getCookieByName('IsSubscriber') === 'True',
            isOverridden = cphGlobal.getQueryStringValueByKey('showBeg') === 'pleez';

        if(!isOverridden && isSubscribed)
            return false;

        if(afterStory.length) {

            //if(isOverridden || document.referrer.match(/google|bing|facebook|twitter|instagram|pinterest/)) {
            $(window).on('resize.showAfterStory scroll.showAfterStory', $.throttle(200, function() {
                if(afterStory.isInViewport()) {
                    $(window).off('.showAfterStory');

                    var fetch = $.get('https://code.pressdemocrat.com/shared/after-article/election-20221109.html');

                    fetch.done(function(data) {
                        afterStory.html(data);
                        cphGlobal.replaceUrl(cphGlobal.updateQueryStringParameter('sba', 'AAS'));
                    }, 'html');
                }
            }));
            //}
        }
    });
}*/

// BIG STORY COVER IMAGE
jQuery(function($) {
    if($('.big-story .article-container').length) {
        var coverImage = $('#bs-cover-photo'),
            scrollDown = $('#bs-scroll-down'),
            scrollIcon = scrollDown.find('.bs-scroll-icon');

        if(coverImage.length) {
            var wHeight = $(window).outerHeight(),
                wWidth = $(window).outerWidth(),
                topper = $('#page-topper'),
                hHeight = topper.outerHeight();

            var loadAndResizeUpdates = function() {
                if(wWidth > wHeight) {
                    coverImage.css({paddingBottom: (wHeight - hHeight) + 'px'}).addClass('fixed');
                    scrollDown.addClass('show');
                } else {
                    coverImage.css({paddingBottom: '65%'}).removeClass('fixed');
                    scrollDown.removeClass('show');
                }
            };

            loadAndResizeUpdates();

            cphLoader.loadThrottleDebounce(function() {
                $(window).on('resize', $.debounce(250, function() {
                    wHeight = $(window).outerHeight();
                    wWidth = $(window).outerWidth();
                    loadAndResizeUpdates();
                }));
            });

            scrollIcon.on('click', function() {
                $('html, body').animate({scrollTop: (coverImage.outerHeight() + coverImage.offset().top)}, 750);
            });
        }
    }
});
jQuery(function($) {
    $('.feature-recipe').each(function() {
        var body = $(document.body),
            recipe = $(this),
            firstChild = recipe.find('>:first-child'),
            title = document.title,
            button = $('<p />', {
                html : $('<a />', {
                    class : 'feature-print-button feature-recipe__print-button recipe__print-button',
                    href : 'javascript:void(0);',
                    html : '<i class="fa fa-print" aria-hidden="true"></i> Print Recipe'
                })
            });

        if(firstChild.is('h1,h2,h3,h4,h5,h6')) {
            firstChild.after(button);
            recipe.data('title', firstChild.text());
        } else {
            recipe.prepend(button);
        }

        button.find('a').click(function(e) {
            e.preventDefault();

            recipe.addClass('feature-being-printed');
            body.addClass('printing-feature');

            document.title = recipe.data('title') || title;

            window.print();

            setTimeout(function() {
                recipe.removeClass('feature-being-printed');
                body.removeClass('printing-feature');

                document.title = title;
            }, 50);
        });
    });
});

// PAW THROUGH ARTICLE CONTENT AND INJECT ADS AND RELATED STORIES
jQuery(function($) {
    if((typeof pageType === 'undefined') || (typeof pageLayout === 'undefined'))
        return;

    var parents = $('.story-content, .big-story .pw-section'),
        triggerAdsAfter = 1500, // ms delay before we look at the article and add the ads. To let js driven elements populate.
        firstAdAfter = 150, // show the first ad this many px down per section
        relatedAfter = 450, // show related stories this many px down first section
        adSpread = $(window).height(), // ###px between tops of ads
        adHeight = 250;

    var doRelatedStories = function() {
        if(pageType !== 'article' || pageLayout !== 'article')
            return;

        if((typeof relatedStories === 'undefined') || (typeof relatedStories.stories === 'undefined'))
            return;

        var rStories = relatedStories.stories;

        if(rStories.length) {
            var relatedParent = parents.length === 1 ? $(parents[0]) : $(parents[1]),
                parentOffset = relatedParent.offset().top,
                relatedChildren = relatedParent.find('> p:visible');

            var positionRelatedBlock = function(block) {
                var blockTop = block.offset().top,
                    blockBottom = blockTop + block.outerHeight();

                var i;
                for(i = 0; i < parents.length; i++) {
                    $(parents[i]).find('div.pd-shortcode-widget').each(function() {
                        var widget = $(this),
                            widgetOffset = widget.offset().top;

                        if(widgetOffset >= blockTop && widgetOffset <= blockBottom) {
                            widget.nextAll('p').first().before(block);
                            positionRelatedBlock(block);
                        }

                        if(widgetOffset > blockBottom) return false;
                    });
                }
            };

            var addRelatedBlock = function(child) {
                var relatedBlock = $('<div class="dynamic-content-block related-stories overlay-stories link-overlay tpl2022__build-block tpl2022--overlay" data-path="relatedStories" data-template="story-list" data-heading="Related Stories" data-ref="related" data-max-stories="3"></div>');

                relatedBlock.insertBefore(child);

                relatedBlock.on('tpl:blockLoaded', function() {
                    positionRelatedBlock(relatedBlock);
                });

                smiBlock.get(relatedParent);

                return false;
            };

            relatedChildren.each(function(i) {
                var child = $(this),
                    childOffset = child.offset().top,
                    fromTop = Math.ceil(childOffset - parentOffset);

                if(child.is('p') && fromTop >= relatedAfter) {
                    addRelatedBlock(child);
                    return false;
                }

                // if not enough paragraphs, put related just before last paragraph
                if((i + 1) === relatedChildren.length) {
                    addRelatedBlock(child);
                    return false;
                }
            });
        }
    };

    var positionPromoSlots = function() {
        var promoSlotIterator = function(promoSlot) {
            if(cphGlobal.hasFloatedObstacle(promoSlot)) {
                var next = promoSlot.next();
                if(next.length) {
                    if(next.is('.article-inline-promo')) {
                        next.remove();
                    } else {
                        promoSlot.insertAfter(next);
                    }
                    promoSlotIterator(promoSlot);
                }
            }
        };

        $('.article-inline-promo').each(function() {
            var promoSlot = $(this),
                inWidget = promoSlot.closest('.pd-shortcode-widget');

            if(inWidget.length)
                promoSlot.insertAfter(inWidget);

            if(promoSlot.prev().is('.article-inline-promo')) {
                promoSlot.remove();
                return;
            }

            promoSlotIterator(promoSlot);
        });
    };

    var doInlineAds = function() {
        if($('#inline-gallery-article').length) return;

        setTimeout(function() {
            var inlineAd = $('<div/>', {class: 'article-inline-ad'}),
                videoAd = $('<div/>', {class: 'article-video-ad'}),
                dummyDiv = $('<div/>', {style: 'display: block; margin: 0; padding: 0; height: 0; overflow: hidden;'});

            var loadInlineAds = function() {
                var adDelay = 0;

                parents.find('.article-inline-ad, .article-video-ad').each(function(i) {
                    var cube = $(this),
                        dataDevices = cube.data('devices'),
                        dataClass = cube.data('class'),
                        dataTargeting = cube.data('targeting'),
                        adClass = null, wrap, ad;

                    adDelay = adDelay + 250;

                    if(dataClass && dataClass !== 'undefined') {
                        adClass = dataClass;
                    }

                    if(cube.is('.article-video-ad')) {

                        wrap = smiDfp.buildAdWrapper('widget-centered', 'height: auto; width: 100%; max-width: 600px; margin-bottom: 1em;');

                        ad = smiDfp.buildAd('phone,tablet,desktop', adClass);
                        ad.addTargeting('location', 'sticky');
                        ad.addTargeting('type', 'article');
                        ad.addSize(600, 1);
                        //ad.setDelay(1000);
                        ad.setNoReload();

                    } else {

                        wrap = smiDfp.buildAdWrapper('widget-centered', 'height: 250px; width: 300px; background-color: #F0F0F0; box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.3);');

                        ad = smiDfp.buildAd('phone,tablet,desktop', adClass);
                        ad.addSize(300, 250);
                        ad.addTargeting('type', 'article');
                        ad.addTargeting('loc', i + 1);
                        //ad.setShowOnScroll();
                        ad.setDelay(adDelay);

                    }

                    if(dataTargeting && dataTargeting !== 'undefined') {
                        $.each(dataTargeting, function(key, value) {
                            ad.addTargeting(key, value);
                        });
                    }

                    ad.wrapWith(wrap);

                    $(this).html(wrap);
                });

                smiDfp.loadAds(parents);
            };

            var inlineAdCount = 0;
            parents.each(function(i) {
                var block = $(this),
                    blockWidth = Math.ceil(block.width()),
                    blockSpread = Math.ceil(adSpread),
                    blockOffset = Math.ceil(block.offset().top),
                    children = block.find('> *'),
                    page = i + 1,
                    lastAdOffset = 0,
                    firstAdAdded, adMarker, adMarkerOffset,
                    dummy, dummyWidth;

                /*if(i === 0) {
                    // was used to add video block to end of first page for mobile, but never used
                    videoAd.clone().data('devices', ['phone']).appendTo(block);
                }*/

                var resetMarkers = function() {
                    adMarker = false;
                    adMarkerOffset = false;
                };

                children.each(function() {
                    var child = $(this);

                    if(child.is('p')) {
                        var childOffset = Math.ceil(child.offset().top) - blockOffset;

                        // if first ad has not been added yet, and we are further than {firstAdAfter} into the block
                        // OR if the child element is further than {blockOffset} below the top of the previous ad
                        if((!firstAdAdded && childOffset >= firstAdAfter) || (childOffset - lastAdOffset) >= blockSpread) {
                            if(!adMarker) {
                                adMarker = child;
                                adMarkerOffset = childOffset;

                                dummy = dummyDiv.clone().insertBefore(child);
                                dummyWidth = dummy.width();
                                dummy.remove();

                                if(dummyWidth !== blockWidth) {
                                    resetMarkers();
                                }
                            }

                            if(adMarker) {
                                var bottomOffset = Math.ceil(childOffset + child.height());

                                if(bottomOffset > (adMarkerOffset + adHeight)) {
                                    dummy = dummyDiv.clone().insertAfter(child);
                                    dummyWidth = dummy.width();
                                    dummy.remove();

                                    if(dummyWidth === blockWidth) {
                                        if(!firstAdAdded && page === 1 && ++inlineAdCount === 1) {
                                            // This is the first ad block on the first page.
                                            // Basically, the first inline ad.
                                            // Leave blank to not insert anything otherwise add code below.
                                            //videoAd.clone().data('devices', ['tablet', 'desktop']).insertBefore(adMarker);
                                            videoAd.clone().insertBefore(adMarker);
                                        } else {
                                            inlineAd.clone().insertBefore(adMarker);
                                        }

                                        firstAdAdded = true;
                                        lastAdOffset = adMarkerOffset;
                                        resetMarkers();
                                    }
                                }
                            }
                        }
                    } else {
                        resetMarkers();
                    }
                });
            });

            loadInlineAds();
        }, triggerAdsAfter);
    };

    doRelatedStories();

    setTimeout(function() {
        positionPromoSlots();

        setTimeout(function() {
            doInlineAds(1000);
        }, 250);
    }, 250);
});
// INIT CPH GALLERY FOR INLINE GALLERY ARTICLE TYPE
jQuery(function($) {
    let inlineGallery = $('#inline-gallery');

    if(!inlineGallery.length) return;

    cphLoader.loadCphGallery(function() {
        let loc = window.location,
            galleryHomeLink = siteConfig.url.base || (loc.protocol + '//' + loc.hostnamee),
            galleryLogoUrl = siteConfig.pub.logoWhite || null,
            galleryLogoAlt = siteConfig.pub.nameExt || null,
            galleryLogo = null;

        if(galleryLogoUrl) {
            galleryLogo = $('<a/>', {
                href : galleryHomeLink,
                html : $('<img/>', {
                    src : galleryLogoUrl,
                    alt : galleryLogoAlt,
                    style : 'max-width: 200px; height: auto;'
                })
            })
        }

        let cphGallery = $.cphGallery({
            logo: galleryLogo,

            banner: '<div id="cphGallery-banner-ad"></div><script>var cphGalWrap,cphGalAd;cphGalWrap=smiDfp.buildAdWrapper();cphGalAd=smiDfp.buildAd("phone");cphGalAd.addTargeting("position","ATF");cphGalAd.addSize(320,50);cphGalAd.setForceReload();cphGalAd.wrapWith(cphGalWrap);cphGalAd=smiDfp.buildAd("tablet");cphGalAd.addTargeting("position","ATF");cphGalAd.addSize(728, 90);cphGalAd.setForceReload();cphGalAd.wrapWith(cphGalWrap);$("#cphGallery-banner-ad").html(cphGalWrap);smiDfp.loadAds($("#cphGallery-banner-ad"));<\/script>',

            cube: '<div id="cphGallery-cube-ad" style="min-height: 250px; width: 300px; background: #EFEFEF;"><script>var cphGalCube=smiDfp.buildAd("desktop");cphGalCube.addTargeting("position","ATF");cphGalCube.addSize(300, 250);cphGalCube.setForceReload();$("#cphGallery-cube-ad").html(cphGalCube.render());smiDfp.loadAds($("#cphGallery-cube-ad"));<\/script>',

            headline: $('div.inline-gallery__title').text(),

            addUrlParam: 'gSlide',

            zIndex: 100000,

            on: {
                show       : function() {
                    $(document).on('onPaywallShown', function(e) {
                        console.log('onPaywallShown');
                        setTimeout(function() {
                            cphGallery.destroy();
                        }, 500);
                    });
                    if($('body').hasClass('has-pw')) {
                        setTimeout(function() {
                            cphGallery.destroy();
                        }, 500);
                    }

                    $('head').append('<style>.cph-gallery__footer-caption a{text-decoration:underline;}</style>');
                },
                slideChange: function() {
                    $(document).trigger('smi:gallerySlide');

                    if(typeof smiDfp.refreshAds === 'function') {
                        smiDfp.refreshAds();
                    } else {
                        console.log('DEBUG: function \'smiDfp.refreshAds\' is undefined');
                    }
                }
            }
        });

        $(document).on('dfpRendered', function(e, adSlot, origEvent) {
            if($(adSlot).closest('#cphGallery-banner-ad').length) {
                cphGallery.update();
            }
        });

        inlineGallery.find('.inline-gallery__hero-image').each(function() {
            let figure = $(this),
                img = figure.find('img');

            if(!img.length) return;

            let imgSrc = img.attr('data-src') || img.attr('src'),
                imgSrcset = img.attr('data-srcset') || img.attr('srcset'),
                imgAlt = img.attr('alt'),
                imgCaption = figure.find('figcaption').html(),
                imgId = cphGallery.md5(imgSrc);

            let button = cphGallery.getOpenIcon(imgId, null, 'inline-gallery__view-all');

            button.find('a').append('&nbsp;View<span id="cph-gallery-photo-count">&nbsp;</span>Photos');

            $('<div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; display: flex; align-items: center; justify-content: center;"></div>').html(button).insertAfter(img);

            cphGallery.addImageLazy(imgId, imgSrc, imgCaption, imgAlt, null, null, imgSrcset, '100vw');
        });

        let igCount = 0,
            igAdOuter, igAdWrap, igAd;

        inlineGallery.find('.inline-gallery__image').each(function() {
            let wrap = $(this),
                figure = $(this).find('> figure'),
                img = figure.find('img');

            if(!img.length) return;

            if((++igCount % 4) === 0) {
                igAdOuter = $('<div class="inline-gallery__ad"/>');

                igAdWrap = smiDfp.buildAdWrapper();

                igAd = smiDfp.buildAd('phone');
                igAd.addTargeting('position', 'big-gallery');
                igAd.addSize(320, 50);
                igAd.wrapWith(igAdWrap);

                igAd = smiDfp.buildAd('tablet,desktop');
                igAd.addTargeting('position', 'big-gallery');
                igAd.addSize(728, 90);
                igAd.wrapWith(igAdWrap);

                igAdOuter.html(igAdWrap);
                wrap.after(igAdOuter);
                smiDfp.loadAds(igAdOuter);
            }

            let imgSrc = img.attr('data-src') || img.attr('src'),
                imgSrcset = img.attr('data-srcset') || img.attr('srcset'),
                imgAlt = img.attr('alt'),
                imgCaption = figure.find('figcaption').html(),
                imgSubhead = wrap.find('> h3').text(),
                imgId = cphGallery.md5(imgSrc);

            img.after(cphGallery.getOpenIcon(imgId, null, 'inline-gallery__view-image'));

            cphGallery.addImageLazy(imgId, imgSrc, imgCaption, imgAlt, imgSubhead, null, imgSrcset, '100vw');
        });

        $('#cph-gallery-photo-count').html('&nbsp;' + cphGallery.slides.length + '&nbsp;');

        cphGallery.ready();
    });
});
jQuery(function($) {
    var scrollContainer = $('article.article-container');

    if(!scrollContainer.length) return;

    var imageContainer = scrollContainer.find('.main-gallery, .big-story-cover, #recipe-cover'),
        scroll0, scroll25, scroll50, scroll75, scroll100;

    function scrollPositionTrigger() {
        var scrollPosition = $(window).scrollTop(),
            articleBottom = scrollContainer.offset().top - $(window).height(),
            imageHeight = imageContainer.height(),
            scrollOffset = scrollPosition - (articleBottom + imageHeight),
            quarterHeight = (scrollContainer.height() - imageHeight) / 4;

        if(!scroll0 && scrollOffset > 0) {
            scroll0 = true;
            $(document).trigger('scroll0');
        } else if(!scroll25 && scrollOffset > quarterHeight) {
            scroll25 = true;
            $(document).trigger('scroll25');
        } else if(!scroll50 && scrollOffset > (2 * quarterHeight)) {
            scroll50 = true;
            $(document).trigger('scroll50');
        } else if(!scroll75 && scrollOffset > (3 * quarterHeight)) {
            scroll75 = true;
            $(document).trigger('scroll75');
        } else if(!scroll100 && scrollOffset > (4 * quarterHeight)) {
            scroll100 = true;
            $(document).trigger('scroll100');
        }
    }

    cphLoader.loadThrottleDebounce(function() {
        $(window).on('scroll.scrollPositionTrigger', $.throttle(1000, function() {
            if(!(scroll0 && scroll25 && scroll50 && scroll75 && scroll100)) {
                scrollPositionTrigger();
            } else {
                $(window).off('scroll.scrollPositionTrigger');
            }
        }));
    });
});

// RESIZE SPLIT IMAGES TO FORCE SAME HEIGHT IN [imageByName:] SHORTCODE
jQuery(function($) {
    $('.pd-widget-position-split').each(function() {
        var split = $(this),
            images = split.find('img'),
            imageNum, aspect, smallerAspect;

        if(images.length === 2) {
            imageNum = 1;
            $.each(images, function() {
                $(this).on('load', function() {
                    aspect = Math.round(($(this).height() / $(this).width()) * 100);

                    if(!smallerAspect || aspect < smallerAspect) {
                        smallerAspect = aspect;
                    }

                    if(imageNum++ === 2) {
                        split.addClass('resized').find('.pd-figure-outer-wrap').css({paddingBottom: smallerAspect + '%'});
                    }
                });
            });
        }
    });
});
// BUILD SWIPER GALLERy BASED ON 'VAR mainGallery' or [gallery:] SHORTCODE
jQuery(function($) {
    var inlineGalleries = $('.smi-inline-gallery'),
        refreshAdsEach = window['refreshAdsEach'] === 'undefined' ? 2 : window['refreshAdsEach'],
        injectAdEvery = 0,
        refreshCounter = 0;

    injectAdEvery = 6; // inject ad after every (n)th slide

    if(typeof mainGallery !== 'undefined' && $.isArray(mainGallery.images)) {
        cphLoader.loadSwiper(function() {
            printGallery($('#main-gallery-container'), mainGallery, true);
        });
    }

    if(inlineGalleries.length) {
        cphLoader.loadSwiper(function() {
            $.each(inlineGalleries, function() {
                var placeholder = $(this),
                    isInline = placeholder.data('image-json'),
                    isByUUID = placeholder.data('uuid'),
                    pWidth = placeholder.width();

                if(isInline && (typeof window[isInline] !== 'undefined')) {
                    printGallery(placeholder, window[isInline]);
                } else if(isByUUID) {
                    var imageSize = 'large';
                    if(typeof window.imageSizes !== 'undefined' && !$.isEmptyObject(window.imageSizes)) {
                        $.each(window.imageSizes, function(size, px) {
                            if(pWidth < px) {
                                imageSize = size;
                                return false;
                            }
                        });
                    }

                    $.getJSON('/smi/feeds/json/images/?uuid=' + isByUUID + '&size=' + imageSize).done(function(data) {
                        printGallery(placeholder, data);
                    });
                }
            });
        });
    }

    function printGallery(placeholder, data, isMainGallery) {
        var galleryOuter = $('<div />', {'class': 'swiper-gallery', 'style': 'overflow: hidden;'}),
            swiperContainer = $('<div />', {'class': 'swiper-container'}),
            swiperWrapper = $('<div />', {'class': 'swiper-wrapper'}),
            captionContainer = $('<div />', {'class': 'cph-gallery-captions'}),
            slideCount = data.images.length,
            gallerySize = placeholder.data('size'),
            galleryPosition = placeholder.data('position'),
            tsmSlide;

        if(placeholder.parent().is('p'))
            placeholder.unwrap();

        if(!gallerySize)
            gallerySize = 'medium';

        if(!galleryPosition)
            galleryPosition = 'full';

        //if(slideCount > 1)
        //tsmSlide = insertGalleryTopStories();

        if(tsmSlide)
            slideCount = slideCount + 1;

        $.each(data.images, function(i, v) {
            var isLastSlide = data.images.length === (i + 1),
                theContent, theCaption, theAltText;

            if(v.video.embed.length > 3) {
                // v.video.embedap for autoplay version
                theContent = '<iframe class="gallery-video" src="" data-src="' + v.video.embed + '" border="0" scrolling="no" allowfullscreen></iframe>';
                theCaption = v.video.caption.length > 3 ? v.video.caption : null;
            } else {
                theCaption = v.image.caption.length > 3 ? v.image.caption : null;
                theAltText = theCaption ? theCaption : 'slide image';
                theAltText = $('<div/>', {
                    html: theAltText
                }).text();

                var imgTag = $('<img/>', {
                    alt: theAltText
                });
                if(isMainGallery && i === 0) {
                    imgTag.attr('src', v.image.href);
                    theContent = imgTag[0];
                } else {
                    imgTag.addClass('swiper-lazy').attr('data-src', v.image.href);
                    theContent = $('<div/>').html([imgTag, $('<div class="swiper-lazy-preloader swiper-lazy-preloader-white"/>')]).html();
                }
            }

            buildGallerySlide(i, theContent, theCaption);

            if(!isLastSlide && isMainGallery && injectAdEvery && $(window).width() > 767 && !$(document.body).is('.ad-lite, .ad-free')) {
                if(i > 0 && (i % injectAdEvery) === 0 && i < data.images.length) {
                    var slideAd = smiDfp.buildAd('phone,tablet,desktop', 'gallery-ad');
                    slideAd.addSize(300, 250);
                    slideAd.setDeferred();

                    theContent = slideAd.render();
                    theCaption = 'Advertisement';

                    buildGallerySlide(i + 'a', theContent, theCaption);
                }
            }
        });

        if(tsmSlide)
            buildGallerySlide((slideCount - 1), tsmSlide, null);

        function insertGalleryTopStories() {
            if(typeof mainGalleryTSM !== 'undefined') {
                if($.isPlainObject(mainGalleryTSM) && mainGalleryTSM.stories.length >= 12) {
                    var thisSlide = $('<div />', {
                        class: 'gallery-tsm-slide',
                        html : $('<h3 />', {text: 'More from The ' + cphPubName})
                    });

                    var contentDiv = $('<div />', {
                        class: 'gallery-tsm-slide-content'
                    });

                    $.each(mainGalleryTSM.stories, function(i, sty) {
                        var storyDiv = $('<div />', {class: 'gallery-tsm-item'}),
                            innerDiv = $('<a />', {
                                class: 'gallery-tsm-item-inner',
                                href : cphGlobal.updateQueryStringParameter('ref', 'GAL', sty.href),
                                html : $('<div />', {
                                    class: 'gallery-tsm-item-gradient'
                                })
                            }),
                            imgDiv = $('<div />', {
                                class: 'gallery-tsm-image-sizer',
                                html : $('<div />', {
                                    class: 'gallery-tsm-image-holder',
                                    html : $('<img />', {src: sty.image.thumb, alt: 'slide recent image'})
                                })
                            }),
                            headline = $('<div />', {class: 'gallery-tsm-title', text: sty.headline});

                        innerDiv.append(imgDiv);
                        innerDiv.append(headline);
                        storyDiv.html(innerDiv);

                        contentDiv.append(storyDiv);
                    });

                    thisSlide.append(contentDiv);

                    return thisSlide;
                }
            }
            return false;
        }

        function buildGallerySlide(slideNum, content, caption) {
            var slideWrapper = $('<div />', {
                'class': 'swiper-slide',
                html   : $('<div />', {'class': 'cph-gallery-container', html: content})
            }).attr('data-caption-id', slideNum).attr('data-art-slide', slideNum);

            var captionWrapper = $('<div />', {'class': 'cph-gallery-caption'}).attr('data-caption-id', slideNum);

            if(slideCount > 1 && $.isNumeric(slideNum)) {
                $('<div />', {
                    'class': 'cph-gallery-slide-count',
                    html   : $('<strong />', {text: 'Slide ' + (slideNum + 1) + ' of ' + slideCount})
                }).appendTo(captionWrapper);
            }

            if(caption) {
                $('<div />', {html: caption}).appendTo(captionWrapper);
            }

            swiperWrapper.append(slideWrapper);
            captionContainer.append(captionWrapper);
        }

        swiperContainer.html(swiperWrapper).append('<div class="swiper-button-next swiper-button-white"></div> <div class="swiper-button-prev swiper-button-white"></div>');

        galleryOuter.html(swiperContainer).append(captionContainer);

        if(!isMainGallery) {
            galleryOuter = cphGlobal.wrapFigures(cphGlobal.wrapWithFigure(galleryOuter), gallerySize, galleryPosition);
        }

        placeholder.replaceWith(galleryOuter);

        initGallery(galleryOuter, isMainGallery);
    }

    function initGallery(gallery, isMainGallery) {
        var swiperContainer = gallery.find('.swiper-container'),
            swiperSlides = swiperContainer.find('.swiper-slide'),
            swiperPrev = swiperContainer.find('.swiper-button-prev'),
            swiperNext = swiperContainer.find('.swiper-button-next'),
            isSingle = swiperSlides.length < 2,
            initialSlide = parseInt(cphGlobal.getQueryStringValueByKey('artslide')),
            firstTransitionSkipped = false;

        initialSlide = (isMainGallery && !isSingle && !isNaN(initialSlide)) ? initialSlide : 0;

        if(isSingle) {
            swiperPrev.add(swiperNext).remove();
            gallery.addClass('is-single-slide');
        } else {
            swiperPrev.add(swiperNext).show();
        }

        new Swiper(swiperContainer[0], {
            navigation        : {
                prevEl: isSingle ? null : swiperPrev[0],
                nextEl: isSingle ? null : swiperNext[0]
            },
            initialSlide      : initialSlide,
            simulateTouch     : !isSingle,
            threshold         : 10,
            grabCursor        : !isSingle,
            loop              : !isSingle,
            preloadImages     : false,
            lazy              : {
                loadPrevNext: true
            },
            runCallbacksOnInit: !isSingle,
            on                : {
                init                      : function() {
                    setSwiperHeight();
                    if(isSingle) doOnTransitionStart(this);
                },
                resize                    : function() {
                    setSwiperHeight();
                },
                slideChangeTransitionStart: function() {
                    doOnTransitionStart(this);
                },
                slideChangeTransitionEnd  : function() {
                    doAfterSlideChange(this);
                }
            }
        });

        function setSwiperHeight() {
            var outerHeight = Math.floor(swiperContainer.width() * 0.75);
            var maxHeight = Math.floor($(window).height() * 0.8);
            outerHeight = (maxHeight < outerHeight) ? maxHeight : outerHeight;

            swiperContainer.css({height: outerHeight + 'px'});
            swiperContainer.find('.cph-gallery-container').css({
                height    : outerHeight + 'px',
                lineHeight: (outerHeight - 4) + 'px'
            });
        }

        function doOnTransitionStart(swiper) {
            var activeSlide = $(swiper.slides[swiper.activeIndex]),
                activeSlideCaptionId = activeSlide.data('caption-id'),
                activeCaption;

            gallery.find('.cph-gallery-caption').hide();
            if(activeSlideCaptionId !== 'undefined') {
                activeCaption = gallery.find('.cph-gallery-caption[data-caption-id=' + activeSlideCaptionId + ']');
                if(activeCaption.length && activeCaption.text().length) {
                    activeCaption.show();
                }
            }

            swiperSlides.find('iframe').attr('src', '');
            activeSlide.find('iframe').each(function() {
                $(this).attr('src', $(this).data('src'));
            });
        }

        function doAfterSlideChange(swiper) {
            var activeSlide = $(swiper.slides[swiper.activeIndex]),
                slideIndex = activeSlide.data('art-slide');

            if(activeSlide.find('.gallery-ad').length) {
                smiDfp.loadDeferredAds(activeSlide);
            }

            if(firstTransitionSkipped) {

                if(isMainGallery) {
                    var newUrl = window.location.href;
                    newUrl = cphGlobal.removeUTM(newUrl);
                    newUrl = cphGlobal.updateQueryStringParameter('ref', false, newUrl);
                    newUrl = cphGlobal.updateQueryStringParameter('slide', false, newUrl);
                    newUrl = cphGlobal.updateQueryStringParameter('artslide', slideIndex, newUrl);

                    // adding param to last slide if it is a gallery slide
                    if(activeSlide.find('.gallery-tsm-slide').length) {
                        newUrl = cphGlobal.updateQueryStringParameter('slide', 'GAL', newUrl);
                    }

                    cphGlobal.replaceUrl(newUrl);
                }

                $(document).trigger('smi:gallerySlide');

                refreshCounter = refreshCounter + 1;
                if(refreshCounter >= refreshAdsEach) {
                    refreshCounter = 0;

                    if(typeof smiDfp.refreshAds !== 'undefined' && $.isFunction(smiDfp.refreshAds)) {
                        smiDfp.refreshAds();
                    } else {
                        console.log('DEBUG: function \'smiDfp.refreshAds\' is undefined');
                    }
                }
            }
            firstTransitionSkipped = true;
        }
    }
});